import { render, staticRenderFns } from "./FieldInfoTypeA.vue?vue&type=template&id=4fbd46bb&scoped=true&"
import script from "./FieldInfoTypeA.vue?vue&type=script&lang=js&"
export * from "./FieldInfoTypeA.vue?vue&type=script&lang=js&"
import style0 from "./FieldInfoTypeA.vue?vue&type=style&index=0&id=4fbd46bb&prod&scoped=true&lang=scss&"
import style1 from "./FieldInfoTypeA.vue?vue&type=style&index=1&id=4fbd46bb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbd46bb",
  null
  
)

export default component.exports